<template>
    <div class="d-flex flex-end col-sm-12 p-md-0" v-if="renderComponent">
        <div id="Statisticstatscore">prova</div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import axios from "axios";

    export default {
        name: 'Statistics',
        data() {
            return {
                renderComponent: false,
            };
        },
        computed: {
            ...mapGetters({
                'getAuthenticated': 'user/getAuthenticated',
                'getId': 'user/getId',
                'getLogin': 'user/getLogin',
                'getEventsDetail': 'odds/getEventsDetail',
                'getViewMode': 'ui/getViewMode',
                'getLanguage': 'settings/getLanguage',
                'getRulesManager': 'rules/getRulesManager',
                'getRulesSkin': 'rules/getRulesSkin',
            }),

        },
        methods: {
            ...mapActions({
                'setPrematchEventStatscore': 'odds/setPrematchEventStatscore',
                'setViewMode': 'ui/setViewMode',
                'destroyEventLive': 'odds/destroyEventLive',
                // 'fetchEventDetail': 'odds/fetchEventDetail',
            }),
            async loadWidget(id_event, sport){

                var checkSkin = _.find(this.getRulesSkin, {"type": "statscoreprematch", "source": sport, "status": true})
                if(!checkSkin){
                    checkSkin = _.find(this.getRulesManager, {"type": "statscoreprematch", "source": sport, "status": true})
                }

                var configuration;
                if(checkSkin){
                    configuration = checkSkin.configuration
                }

                // var id_event = await this.getEventsDetail[0].sourceStatscore;
                // console.log('id_event: ', id_event)
                // console.log('checkSkin: ', checkSkin)
                if (id_event && checkSkin) {
                    var result = await axios({
                        method: 'get',
                        url: 'https://api.statscore.com/v2/booked-events?client_id=1256&product=prematchcenter&events_details=no&client_event_id=' + id_event,
                        // url: 'https://api.statscore.com/v2/booked-events?client_id=1256&product=livescorepro&events_details=no&client_event_id=' + id_event,
                        headers: {
                            'content-type': 'application/json'
                        }
                    });

                    if (result.data.api.method.total_items > 0) {

                        this.renderComponent = true;

                        await this.setPrematchEventStatscore(true);

                        var d = "STATSCOREWidgetsEmbederScript";
                        if (!window.document.getElementById(d)) {
                            window.STATSCOREWidgets = {},
                                window.STATSCOREWidgets.onLoadCallbacks = [],

                                window.STATSCOREWidgets.onLoad = function (d) {
                                    window.STATSCOREWidgets.onLoadCallbacks.push(d)
                                };
                            var n = window.document.createElement("script");
                            n.src = "https://wgt-s3-cdn.statscore.com/bundle/Embeder.js",
                                n.async = !0,
                                n.id = d,
                                n.addEventListener("error", function (d) {
                                    for (var n = 0; n < window.STATSCOREWidgets.onLoadCallbacks.length; n++) window.STATSCOREWidgets.onLoadCallbacks[n](d)
                                }),
                                window.document.body.appendChild(n)
                        }

                        // Hook up when library is loaded and ready to use.
// You can use this method as many times as necessary - if library
// is already loaded provided callback will fire immediately
                        STATSCOREWidgets.onLoad(err => {
                            if (err) {
                                switch (err.type) {
                                    case 'NetworkError':
                                        // Handle network error here
                                        break;

                                    case 'BrowserNotSupported':
                                        // Handle unsupported browser here
                                        break;
                                }

                                return;
                            }

                            // Widget will be appended to this HTMLElement.
                            //
                            // If you are using framework then follow its documentation
                            // on how to get DOM Element from your component.
                            // Vue.js https://vuejs.org/v2/api/#ref
                            // React https://en.reactjs.org/docs/refs-and-the-dom.html
                            // Angular https://angular.io/api/core/ElementRef
                            const element = document.getElementById('Statisticstatscore');

                            // Configuration that you should receive from STATSCORE
                            const configurationId = configuration; //624b28cc9613b7a8f539e817

                            // Input data for widget type you want to embded
                            const inputData = {eventId: 'm:' + id_event, language: this.getLanguage};

                            // Optional object with options.
                            // You can check available options further in the docs.
                            const options = {};

                            const widget = new window.STATSCOREWidgets.Widget(element, configurationId, inputData, options);
                        });

                    }else{
                        this.renderComponent = false;
                    }
                }else{
                    return {
                        data:'notFound'
                    }
                }
            }
        },

        async mounted() {

            // await this.fetchEventDetail({'source': this.$route.query.id_event, 'group': 0,'sport':this.$route.query.sport,'tournament':this.$route.query.tournament, 'status':this.$route.query.status});

            if(this.$route.query.id_event) {
                await this.loadWidget(this.$route.query.id_event, this.$route.query.sport, this.$route.query.tournament, this.$route.query.status)
            }
        }

    };
</script>
